<script lang="ts">
	import { PortableText } from "@portabletext/svelte";
	import type { PortableTextBlock } from "@portabletext/types";
	import CheckmarkList from "./CheckmarkList.svelte";

	interface Props {
		portableText: { value: PortableTextBlock[] };
	}

	let { portableText }: Props = $props();
</script>

<CheckmarkList class="my-4" wrapper>
	<PortableText value={portableText.value} onMissingComponent={false} />
</CheckmarkList>
